import React from 'react';
import styles from './RecordCompareSelectAll.module.scss';
import SelectAll from './RecordCompareSelectAll';
export default function UnSelectAll(props) {
  return /*#__PURE__*/React.createElement(SelectAll, Object.assign({
    className: styles.unselect
  }, props, {
    i18nKey: "@dm/components.record-compare.labels.unselect-all"
  }));
}